import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CustomDelete, EditWithIcon, SimpleTextEditor } from 'components';
import { postedNoteActions } from 'store';
import { Images, renderDate, useModal } from 'utils';
import { AddPostedNote } from './addPostedNote';
import { DELETE_POSTED_NOTE_ACTION, POSTED_NOTE_SUBTITLE, POSTED_NOTE_VISIBILITY } from './constants';

/**
 * Posted Note detail — opened as a centered modal from the Goals toolbar badge. Shows the note in a
 * read-only card with edit + delete actions. Reads the note from redux so it reflects the latest
 * value; edit/delete reuse the shared modal system (opening one replaces this modal).
 */
export const PostedNoteDetail = ({ clientId }) => {
    const dispatch = useDispatch();
    const { open } = useModal();
    const postedNote = useSelector((state) => state.postedNote.postedNote);

    if (!postedNote?.content) return null;

    const openEdit = () => open(<AddPostedNote clientId={clientId} info={postedNote} />);

    const openDelete = () =>
        open(
            <CustomDelete
                info={'Delete Posted Note?'}
                text={'This note will no longer be visible to the therapist during data collection.'}
                innerText={'Delete'}
                actionType={DELETE_POSTED_NOTE_ACTION}
                handleDel={() => dispatch(postedNoteActions.deletePostedNote(clientId))}
            />
        );

    const author = postedNote?.updatedBy;
    const authorName = author ? [author.firstName, author.lastName].filter(Boolean).join(' ') : '';
    const metaAuthor = authorName ? `Updated by ${authorName}${author?.credential ? `, ${author.credential}` : ''}` : '';
    const metaDate = postedNote?.updatedAt ? renderDate(postedNote.updatedAt) : '';
    const meta = [POSTED_NOTE_VISIBILITY, metaAuthor, metaDate].filter(Boolean).join(' · ');

    return (
        <div className="posted-note-detail-modal">
            <div className="posted-note-detail__head">
                <p className="modal-header-title">Posted Note</p>
                <div className="flex-align-center" style={{gap: 8}}>
                    <EditWithIcon
                        icon={Images.edit}
                        handleClick={openEdit}
                    />
                    <EditWithIcon
                        icon={Images.redTrash}
                        handleClick={openDelete}
                    />
                </div>
            </div>
            <p className="posted-note-subtitle">{POSTED_NOTE_SUBTITLE}</p>
            <div className="posted-note-card">
                <div className="posted-note-card__body">
                    <SimpleTextEditor value={postedNote?.content} readOnly border={'none'} />
                </div>
                {meta && <p className="posted-note-card__meta">{meta}</p>}
            </div>
        </div>
    );
};
